import styled, { keyframes } from 'styled-components';

import { GoatLogo } from 'shared/icons/GoatLogo';

export const GoatOverlay = () => (
  <GoatOverlay.Container data-qa="goat_overlay">
    <GoatOverlay.ImageContainer>
      <GoatLogo width={120} fill="white" data-qa="overlay_goat_image" />
    </GoatOverlay.ImageContainer>
  </GoatOverlay.Container>
);

const shrink = keyframes` 
  0% { transform:scale(1); opacity: 1; }
  17% { opacity: 1; } 
  100% { transform:scale(0.5); opacity: 1; }
`;

const front = (theme) => keyframes`
  0% { z-index: ${theme.zIndex.pageOverlay}; transform: scale(1); opacity: 1; }
  50% { z-index: ${theme.zIndex.pageOverlay}; transform: scale(1); opacity: 1; }
  65% { z-index: ${theme.zIndex.pageOverlay}; transform: scale(1); opacity: 0; }
  100% { z-index: -1; transform: scale(0); opacity: 0; }
`;

GoatOverlay.Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  height: 100vh;
  width: 100vw;
  background: ${({ theme }) => theme.colors.black};

  animation: ${({ theme }) => front(theme)} 1s linear forwards;
  z-index: -1;
  opacity: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    max-width: 100%;
  }
`;

GoatOverlay.ImageContainer = styled.div`
  animation: ${shrink} 1s linear;
  opacity: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    width: 10vw;
  }
`;
